// Core imports
import Highcharts12 from "highcharts-v12";
import { highchartsThemeDefault } from "./themes/highchartsThemes";

// v12 imports
import HighchartsMore12 from "highcharts-v12/highcharts-more";
import hcColorAxis12 from "highcharts-v12/modules/coloraxis";
import hcHeatmap12 from "highcharts-v12/modules/heatmap";
import hcMap12 from "highcharts-v12/modules/map";
import bullet12 from "highcharts-v12/modules/bullet";
import solidgauge12 from "highcharts-v12/modules/solid-gauge";
import boost12 from "highcharts-v12/modules/boost";
import hcCluster12 from "highcharts-v12/modules/marker-clusters";
import hcAccessibility12 from "highcharts-v12/modules/accessibility";
import hcNoData12 from "highcharts-v12/modules/no-data-to-display";
import funnelv12 from "highcharts-v12/modules/funnel";

function highchartsSetupV12() {
  highchartsSettingsV12();
  Highcharts12.setOptions(highchartsThemeDefault);
}

function highchartsSettingsV12() {
  if (typeof HighchartsMore12 === "function") {
    HighchartsMore12(Highcharts12);
  }
  if (typeof hcColorAxis12 === "function") {
    hcColorAxis12(Highcharts12);
  }
  if (typeof hcHeatmap12 === "function") {
    hcHeatmap12(Highcharts12);
  }
  if (typeof hcMap12 === "function") {
    hcMap12(Highcharts12);
  }
  if (typeof bullet12 === "function") {
    bullet12(Highcharts12);
  }
  if (typeof solidgauge12 === "function") {
    solidgauge12(Highcharts12);
  }
  if (typeof boost12 === "function") {
    boost12(Highcharts12);
  }
  if (typeof hcCluster12 === "function") {
    hcCluster12(Highcharts12);
  }
  if (typeof hcAccessibility12 === "function") {
    hcAccessibility12(Highcharts12);
  }
  if (typeof hcNoData12 === "function") {
    hcNoData12(Highcharts12);
  }
  if (typeof funnelv12 === "function") {
    funnelv12(Highcharts12);
  }
}

export { highchartsSetupV12, highchartsSettingsV12 };
